import React, { ReactNode } from "react"

type Props = {
  children?: ReactNode
}
const H2: React.FC<Props> = ({ children }) => (
  <h2 className="h2">{children}</h2>
)

export default H2
